const closestElementShadow = (selector, base) => {
  const closestFrom = (el) => {
    if (!el || el === document || el === window) {
      return null;
    }
    const found = el.closest(selector);
    return found
      ? found
      : closestFrom(el.getRootNode().host);
  };
  return closestFrom(base);
};
const getComponentClosestLanguage = (element) => {
  let closestElement = closestElementShadow("[lang]", element);
  /**
   * As of now we do not support more languages other than Dutch (nl) and English (en).
   * We've seen multiple values being used, both valid and invalid values (hyphen, underscore), language only (e.g. "en") but also including the country (e.g "en-GB").
   * The code below is a simple version to only look at the language as we (currently)don't support country specific differences (eg "de" or "de-AT").
   */
  if (closestElement && closestElement.lang) {
    const lowerCasedLanguage = String(closestElement.lang).toLowerCase();
    if (lowerCasedLanguage.startsWith("nl")) {
      return "nl";
    }
    if (lowerCasedLanguage.startsWith("en")) {
      return "en";
    }
    if (lowerCasedLanguage === "") {
      return "nl";
    }
  }
  return "nl";
};
const getLanguage = (element) => {
  return getComponentClosestLanguage(element);
};

export { getLanguage as g };
